exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".calendar-head[data-v-bed43a66]{text-align:center;text-transform:uppercase;background-color:#dedede;color:#797979;font-size:11px;padding:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bed43a66","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calendar/head/component.vue
// module id = de95ea3939be1b971351
// module chunks = 0